import React from "react";
import {Button} from "../../HTMLEntities/Button";
import {SignUpButtonArea, LoginEllipsisAnimation} from "../../Registration/widgets/Styled";
interface Props {
    heading: string;
    isSubmitting: boolean;
    isDisabled: boolean;
    submittingHeading?: string;
}
const SubmitButton: React.FC<Props> = ({
    heading,
    isDisabled,
    isSubmitting,
    submittingHeading,
}: Props) => {
    return (
        <SignUpButtonArea isSubmitting={isSubmitting}>
            <Button type="submit" orange disabled={isDisabled}>
                {isSubmitting && submittingHeading ? (
                    <LoginEllipsisAnimation>
                        {submittingHeading}
                        <span />
                        <span />
                        <span />
                    </LoginEllipsisAnimation>
                ) : (
                    heading
                )}
            </Button>
        </SignUpButtonArea>
    );
};

export default SubmitButton;
